<div (click)="onClick()" class="wrapper">
  <div [title]="'Title'" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile}">
    <i class="material-symbols-outlined my-location-icon" [ngClass]="{'selected' : drawingMode}">stylus</i>
  </div>
</div>
